import React from 'react';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import { ModalProps, MentalHealth, NetworkStatus } from '../../utils/types';
import { LinkStyles, Strong, Paragraph } from '../../theme';
import CloseIcon from './CloseIcon';

interface NotSureMentalHealthModalProps extends ModalProps {
    mentalHealths: MentalHealth;
    handleMentalHealthSelect: (mentalHealth: NetworkStatus) => void;
}

const NotSureMentalHealthModal = ({ open, mentalHealths, handleClose, handleMentalHealthSelect }:NotSureMentalHealthModalProps): JSX.Element => {
    return (
        <Dialog
            maxWidth='md'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '30px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Paragraph sx={{ mb: 2 }}>
                        <Strong
                            onClick={() => { handleMentalHealthSelect(mentalHealths.commercial); }}
                            sx={LinkStyles}
                            style={{ display: mentalHealths.commercial === NetworkStatus.NotAvailable ? 'none' : 'initial' }}
                        >
                            Commercial
                        </Strong>
                        : This applies to insurance you get through your employer or on the exchange.
                    </Paragraph>
                    <Paragraph sx={{ mb: 2 }}>
                        <Strong
                            onClick={() => { handleMentalHealthSelect(mentalHealths.medicareAdvantage); }}
                            sx={LinkStyles}
                            style={{ display: mentalHealths.medicareAdvantage === NetworkStatus.NotAvailable ? 'none' : 'initial' }}
                        >
                            Medicare
                        </Strong>
                        : This applies to people older than 65 years old and/or with disabilities who have a
                        Medicare Advantage plan. If you have Original Medicare (Medicare part B), then you are in-network.
                    </Paragraph>
                    <Paragraph sx={{ mb: 2 }}>
                        <Strong
                            onClick={() => { handleMentalHealthSelect(mentalHealths.mediCal); }}
                            sx={LinkStyles}
                            style={{ display: mentalHealths.mediCal === NetworkStatus.NotAvailable ? 'none' : 'initial' }}
                        >
                            Medi-Cal
                        </Strong>
                        : We unfortunately do not accept Medi-Cal as a primary form of insurance.
                    </Paragraph>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default NotSureMentalHealthModal;
